// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3T_KW","head":"ProcedureTableInfo_head__1U4h9"};